import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { subscribeTrack, toggleTrack } from "../lib/audio";
import Flower from "./Flower";

const Squiggle = ({ active, stroke = "#2A2118" }) => (
  <span data-testid="bg-music-wave" className={`block w-16 overflow-hidden transition-opacity ${active ? "" : "opacity-30"}`} aria-hidden="true">
    <svg viewBox="0 0 128 16" className={`w-32 h-3 ${active ? "animate-squiggle" : ""}`} fill="none">
      <path
        d="M0 8 Q4 1 8 8 T16 8 T24 8 T32 8 T40 8 T48 8 T56 8 T64 8 T72 8 T80 8 T88 8 T96 8 T104 8 T112 8 T120 8 T128 8"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  </span>
);

const Star = ({ className = "w-7 h-7", spinning = false }) => (
  <span className={spinning ? "inline-block animate-spin-slow" : "inline-block"} style={spinning ? { animationDuration: "9s" } : undefined}>
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d="M12 1.5 L14.2 9.8 L22.5 12 L14.2 14.2 L12 22.5 L9.8 14.2 L1.5 12 L9.8 9.8 Z" fill="#C59B27" />
    </svg>
  </span>
);

export default function FloatingPlayer() {
  const [playing, setPlaying] = useState(false);
  useEffect(() => subscribeTrack(setPlaying), []);
  const { pathname } = useLocation();
  const isPE = pathname.startsWith("/prismatic-essence");

  if (isPE) {
    return (
      <button
        data-testid="bg-music-toggle"
        onClick={toggleTrack}
        aria-pressed={playing}
        aria-label={playing ? "Pause The Essence" : "Play The Essence"}
        className="fixed bottom-5 right-5 z-[90] flex items-center gap-3 rounded-full border border-pe-gold/50 bg-pe-ivory/90 backdrop-blur-md pl-3.5 pr-5 py-2.5 shadow-[0_12px_32px_rgba(44,58,40,0.14)] hover:-translate-y-0.5 transition-transform"
      >
        <Star spinning={playing} />
        <span className="text-left">
          <span data-testid="bg-music-title" className="block font-sans text-[9px] tracking-[0.25em] uppercase text-pe-olive leading-tight">
            {playing ? "Now playing" : "Paused"}
          </span>
          <span className="block font-pe italic text-base leading-tight text-pe-forest">The Essence</span>
          <Squiggle active={playing} stroke="#C59B27" />
        </span>
      </button>
    );
  }

  return (
    <button
      data-testid="bg-music-toggle"
      onClick={toggleTrack}
      aria-pressed={playing}
      aria-label={playing ? "Pause the hub theme" : "Play the hub theme"}
      className="fixed bottom-5 right-5 z-[90] flex items-center gap-3 rounded-full border-2 border-en-ink bg-en-yellow text-en-ink pl-2.5 pr-5 py-2 shadow-[4px_4px_0_#2A2118] hover:-translate-y-0.5 transition-transform"
    >
      <span className={playing ? "animate-spin-slow" : ""} style={playing ? { animationDuration: "4s" } : undefined}>
        <Flower className="w-8 h-8" petals={playing ? "#E85D9E" : "#FBF3E4"} center="#2A2118" />
      </span>
      <span className="text-left">
        <span data-testid="bg-music-title" className="block font-mono text-[9px] tracking-[0.18em] uppercase leading-tight">
          {playing ? "now playing" : "paused"} — hub theme
        </span>
        <span className="block font-hand text-base leading-tight text-en-ink/80 -rotate-1">nelle's mixdown</span>
        <Squiggle active={playing} />
      </span>
    </button>
  );
}
